module.exports = __webpack_public_path__ + "static/media/bg-product-inactive.6148c669.png";